/**
 * Apollo fetchMore `updateQuery` that appends the next page of a paged list
 * query (`data[field] = { items, count }`), skipping items already loaded.
 * Apollo applies it to the query's current variables, so a page requested for
 * an earlier search would land in the new search's results: `isStale()`
 * returning true drops that late page and keeps the current results.
 */
const appendFetchMorePage = (field, isStale) => (previous, { fetchMoreResult }) => {
	const nextItems = fetchMoreResult?.[field]?.items;
	if (isStale() || !nextItems?.length || !previous?.[field]) {
		return previous;
	}

	const knownIds = new Set(previous[field].items.map(item => item.id));
	return {
		[field]: {
			...fetchMoreResult[field],
			items: [...previous[field].items, ...nextItems.filter(item => !knownIds.has(item.id))],
		},
	};
};

export default appendFetchMorePage;
